<div class="bodycontent">

  <div class="subheader with-padding flgrow">
    <div class="row">

      <!-- Dealer Selection -->
      <div class="col-lg-2 col-md-3 col-sm-6" *ngIf="dealers && dealers?.length > 0">
        <div class="input-group">
          <ng-select class="w-100" [class.is-invalid]="isDealerRequired"
            placeholder="{{ 'lblSelectDealer' | translate }}" [(ngModel)]="dealerId" name="dealerId"
            (change)="onDealerChange($event)">
            <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
              {{dealer.name}}
            </ng-option>
          </ng-select>
        </div>
        <div *ngIf="isDealerRequired" class="invalid-feedback d-block">
          <small class="text-danger" translate>lblRequiredDealer</small>
        </div>
      </div>

      <!-- Mechanic Selection -->
      <div class="col-lg-2 col-md-3 col-sm-6">
        <div class="input-group">
          <ng-select class="w-100" [class.is-invalid]="isMechanicRequired"
            placeholder="{{ 'lblSelectMechanic' | translate }}" [(ngModel)]="mechanicId" name="mechanicId"
            (change)="onSelectMechanic($event)" [disabled]="!dealerId || mechanicList.length === 0">
            <ng-option *ngFor="let mechanic of mechanicList" [value]="mechanic.id">
              {{mechanic.name}}
            </ng-option>
          </ng-select>
        </div>
        <div *ngIf="isMechanicRequired" class="invalid-feedback d-block">
          <small class="text-danger" translate>lblRequiredMechanic</small>
        </div>
      </div>

      <!-- Date Range Selection -->
      <div class="col-lg-2 col-md-3 col-sm-6">
        <div class="date">
          <input bsDaterangepicker name="StampInDate" [bsConfig]="myDateRangePickerOptions" class="form-control"
            [(ngModel)]="stampInDate" (ngModelChange)="onDateRangeChanged($event)" placeholder="Select Date Range" />
        </div>
      </div>

      <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 0;">
        <div class="d-flex align-items-center">
          <!-- Search Button -->
          <button type="button" (click)="onSearchReport()" class="btn btn-primary btn-md mr-2"
            [disabled]="!dealerId || !mechanicId || !stampInDate || stampInDate.length < 2"
            ngbTooltip="{{'lblSearch' | translate}}" placement="bottom">
            <em class="fa fa-search"></em>
          </button>
          <!-- Refresh Button -->
          <button type="button" class="btn btn-outline-primary btn-md mr-2" (click)="refresh()" 
          [disabled]="!dealerId || !mechanicId || !stampInDate || stampInDate.length < 2 || !isSearched"
            ngbTooltip="{{'lblRefresh' | translate}}" placement="bottom" aria-label="Center Align">
            <em class="fas fa-sync fa-lg"></em>
          </button>
          <!-- Reset Button -->
          <button type="button" (click)="onReset()" class="btn btn-primary btn-md"
            ngbTooltip="{{ 'lblClearFilters' | translate }}" placement="bottom" aria-label="Center Align">
            <em class="far fa-times-circle font16 align-top"></em>
          </button>
        </div>
      </div>

      <!-- Export Buttons -->
      <div
        class="col-xl-2 col-md-3 col-lg-1 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
        <div class="d-flex align-items-center">
          <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}" placement="left"
            aria-label="Center Align" class="mr-2"
            [disabled]="!dealerId || !mechanicId || !stampInDate || stampInDate.length < 2 || !isSearched">
            <img src="./../../../assets/images/excel.png" height="32" width="32" alt="Excel" />
          </button>
          <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()"
            ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align"
            [disabled]="!dealerId || !mechanicId || !stampInDate || stampInDate.length < 2 || !isSearched">
            <em class="far fa-file fa-2x"></em>
            <span class="bdg">PDF</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container prel" *ngIf="isMechanicSelected">
    <div class="row">
      <div class="c12">
        <div class="card mb-3">
          <!-- Body Header -->
          <div class="card-header d-flex justify-content-between" translate>
            lblTimeStampReport
            <div class="font16 fontbold">
              <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
              {{ totalCount }}
              &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
            </div>
          </div>

          <!-- Body Content -->
          <div *ngIf="!isSingleDateSelected" class="table-responsive max-h254" infinite-scroll
            [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false"
            (scrolled)="onScrollDown()">
            <table class="tablest1" id="timeStampPdf">
              <thead>
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th scope="col" class="text-right" translate>
                    lblMechanicNumber
                  </th>
                  <th scope="col" class="text-right" translate>
                    lblMechanicName
                  </th>
                  <th scope="col" sortable="StampIn" class="text-right" translate (sort)="onSort($event)">
                    lblStampIn
                  </th>
                  <th scope="col" sortable="StampOut" class="text-right" translate (sort)="onSort($event)">
                    lblStampOut
                  </th>
                  <th scope="col" class="text-right" translate>
                    lblStandardTime
                  </th>
                  <th scope="col" class="text-right" translate>
                    lblTimeConsumed
                  </th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngIf="timeStampList?.length > 0; else load_NotFound_Template">
                  <tr *ngFor="let item of timeStampList; let i = index"
                    (click)="getTimeStampDetails(viewTimeStamp, item)">
                    <td class="click">{{ i + 1 }}</td>
                    <td class="text-right click">
                      <div>
                        <ngb-highlight [result]="item.mechanicNumber"> </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right click">
                      <div>
                        <ngb-highlight [result]="item.name" tooltipClass="custom-revert"> </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right click">
                      <div>
                        <ngb-highlight [result]="item.stampIn | date: dateTimeFormat" tooltipClass="custom-revert">
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right click">
                      <div>
                        <ngb-highlight [result]="item.stampOut ? (item.stampOut | date: dateTimeFormat) : ''"></ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right click">
                      <div>
                        <ngb-highlight [result]="item.totalTime"> </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right click">
                      <div>
                        <ngb-highlight [result]="item.timeConsumed"> </ngb-highlight>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
          <ng-container *ngIf="isSingleDateSelected">
            <app-time-stamp-details-grid [timeStampDetails]="timeStampDetails"></app-time-stamp-details-grid>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #viewTimeStamp let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lblSummary
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
        aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body table-responsive">
    <app-time-stamp-details-grid [timeStampDetails]="timeStampDetails"></app-time-stamp-details-grid>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')" translate><em
        class="far fa-times-circle font15 align-top mr-2"></em>lblClose</button>
  </div>
</ng-template>